import { render, staticRenderFns } from "./reset-password-send-otp.vue?vue&type=template&id=1d1619d4&scoped=true&"
import script from "./reset-password-send-otp.vue?vue&type=script&lang=js&"
export * from "./reset-password-send-otp.vue?vue&type=script&lang=js&"
import style0 from "./reset-password-send-otp.vue?vue&type=style&index=0&id=1d1619d4&lang=scss&scoped=true&"
import style1 from "@/assets/auth-screen.scss?vue&type=style&index=1&id=1d1619d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1619d4",
  null
  
)

component.options.__file = "reset-password-send-otp.vue"
export default component.exports